import React, { useEffect, useState } from "react";
import DashboardSideBar from "./DashboardSideBar";
import Search from "../assets/inactive.svg";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { PaginationControl } from "react-bootstrap-pagination-control";

const AllResponses = () => {
  const Apiurl = process.env.REACT_APP_API_KEY;
  const [activeIndex, setActiveIndex] = useState(0);
  const [responsearray, setResponsearray] = useState([]);
  const [filteredResponses, setFilteredResponses] = useState([]);
  const [show, setShow] = useState(false);
  const [brief, setBrief] = useState("");
  const [detail, setDetail] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleClick = (index) => {
    setActiveIndex(index);
    updateapi(filteredResponses[index]);
  };

  const handleDetailChange = (event) => {
    setDetail(event.target.value);
  };

  const handleBriefChange = (event) => {
    setBrief(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    filterResponses(event.target.value);
  };

  const filterResponses = (query) => {
    if (query === "") {
      setFilteredResponses(responsearray);
    } else {
      const filtered = responsearray.filter((response) =>
        response.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredResponses(filtered);
    }
  };

  const responseapi = () => {
    axios
      .get(`${Apiurl}/all_queries`)
      .then((res) => {
        const queries = res.data.all_queries
          .slice(0, 100)
          .map((query) => query.trim()); // Trim each query
        setResponsearray(queries);
        setFilteredResponses(queries);
        if (queries.length > 0) {
          updateapi(queries[0]);
        }
      })
      .catch((err) => console.log(err));
  };

  const updateapi = (item) => {
    const logintoken = localStorage.getItem("authToken");
    const updateddata = {
      query: item,
      short_response: brief,
      detailed_response: detail,
    };
    axios
      .post(`${Apiurl}/admin/get_responses`, updateddata, {
        headers: {
          "x-access-token": logintoken,
        },
      })
      .then((response) => {
        setBrief(response.data.short_response || "");
        setDetail(response.data.detailed_response || "");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const deleteapi = (data) => {
    const logintoken = localStorage.getItem("authToken");
    axios
      .delete(`${Apiurl}/admin/delete_response`, {
        headers: {
          "x-access-token": logintoken,
        },
        data: { query: data },
      })
      .then((delres) => {
        const updatedResponses = responsearray.filter((item) => item !== data);
        console.log(updatedResponses);
        setResponsearray(updatedResponses);
        setFilteredResponses(updatedResponses);

        if (updatedResponses.length > 0) {
          setActiveIndex(0);
          updateapi(updatedResponses[0]);
        } else {
          setActiveIndex(-1);
          setBrief("");
          setDetail("");
        }

        handleClose();
        toast.success("Response Deleted Successfully!", { toastId: "delete" });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const shortupdate = () => {
    if (brief.trim() === "") {
      toast.warning("Brief Prompt cannot be empty!", {
        toastId: "emptyBrief",
      });
      return;
    }

    axios
      .post(`${Apiurl}/s_query`, {
        user_query: responsearray[activeIndex],
        gpt_response: brief,
      })
      .then((response) => {
        toast.success("Brief Prompt Updated Successfully!", {
          toastId: "shortupdated",
        });
      });
  };

  const longupdate = () => {
    if (detail.trim() === "") {
      toast.warning("Detail Prompt cannot be empty!", {
        toastId: "emptyDetail",
      });
      return;
    }

    axios
      .post(`${Apiurl}/d_query`, {
        user_query: responsearray[activeIndex],
        gpt_response: detail,
      })
      .then((response) => {
        toast.success("Detail Prompt Updated Successfully!", {
          toastId: "longupdated",
        });
      });
  };

  useEffect(() => {
    responseapi();
  }, []);

  const itemsPerPage = 9;
  const totalItems = filteredResponses.length;
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedResponses = filteredResponses.slice(startIndex, endIndex);

  return (
    <DashboardSideBar>
      <div className="dashAllresp w-100">
        <div className="main d-flex">
          <div className="all-responses">
            <h1 className="AllRes">All Responses</h1>
            <div className="all-Main">
              <div className="all-Header">
                <div className="left-Main">
                  <div className="left-head">
                    <div className="head-next">
                      <input
                        type="text"
                        className="search"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                      <img className="searchIcon" src={Search} alt="" />
                    </div>
                    <div className="allResp">
                      {Array.isArray(paginatedResponses) ? (
                        paginatedResponses.map((item, index) => {
                          const updatedwords =
                            item.length > 35
                              ? `${item.substring(0, 35)}...`
                              : item;
                          return (
                            <p
                              key={index}
                              value={item}
                              className={`responses d-flex justify-content-center w-100 ${
                                activeIndex === startIndex + index
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => handleClick(startIndex + index)}
                            >
                              {updatedwords}
                            </p>
                          );
                        })
                      ) : (
                        <p>No responses available</p>
                      )}
                    </div>
                    {filteredResponses.length > 9 ? (
                      <PaginationControl
                        page={page}
                        between={1}
                        total={totalItems}
                        limit={itemsPerPage}
                        changePage={(page) => {
                          setPage(page);
                        }}
                        ellipsis={1}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <hr />
                <div className="right-Main">
                  <div className="right-head">
                    <div className="allResptop">
                      <div className="responses">
                        <p className="brief">Query</p>
                      </div>
                      <textarea
                        className="textArea top-head"
                        name=""
                        id=""
                        value={filteredResponses[activeIndex] || ""}
                        readOnly
                      ></textarea>
                    </div>
                    <div className="allResptop">
                      <div className="responses">
                        <p className="brief">Brief Prompt</p>
                        <button className="update" onClick={shortupdate}>
                          Update
                        </button>
                      </div>
                      <textarea
                        className="textArea"
                        name=""
                        id=""
                        value={brief}
                        onChange={handleBriefChange}
                      ></textarea>
                    </div>
                    <div className="allRespbot">
                      <div className="responses">
                        <p className="brief">Detail Prompt</p>
                        <button className="update" onClick={longupdate}>
                          Update
                        </button>
                      </div>
                      <textarea
                        className="textArea resize"
                        name=""
                        id=""
                        rows={15}
                        value={detail}
                        onChange={handleDetailChange}
                      ></textarea>
                    </div>
                  </div>
                  <div
                    className="delete_btn pointer"
                    onClick={handleShow}
                    style={{ cursor: "pointer" }}
                  >
                    <button>Delete Response</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="model-Main"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Body className="model-Body">
          <p>Are you sure you want to delete this response?</p>
          <div className="model-bdy">
            <button
              className="yes"
              onClick={() => deleteapi(filteredResponses[activeIndex])}
            >
              Yes
            </button>
            <button className="no" onClick={handleClose}>
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </DashboardSideBar>
  );
};

export default AllResponses;
